module.exports = __webpack_public_path__ + "media/images/2-eef11154bcfb2141fff3c0ce664a095f.jpg";